import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMobileContext } from "../../contexts";
import { LegendWarriorDesktopCard } from "./LegendWarriorDesktopCard";
import { LegendWarriorMobileCard } from "./LegendWarriorMobileCard";
export function LegendCard(props) {
    var _a = props.data, name = _a.name, cardSubText = _a.cardSubText, key = _a.key, image288x360url = _a.image288x360url, image104x141url = _a.image104x141url;
    var isMobile = useIsMobileContext();
    return isMobile
        ? _jsx(LegendWarriorMobileCard, { name: name, cardSubText: cardSubText, imageUrl: image104x141url, to: "/club/history/legends/".concat(key) })
        : _jsx(LegendWarriorDesktopCard, { name: name, cardSubText: cardSubText, imageUrl: image288x360url, to: "/club/history/legends/".concat(key) });
}
